export const nameMatch = /^(([a-zA-ZęèéêêëėēóôöòõœøōąàáâäæãåāśßšłżźžćçčńñĘÈÉÊÊËĖĒÓÔÖÒÕŒØŌĄÀÁÂÄÆÃÅĀŚŠŁŻŹŽĆÇČŃÑ-])+(\s)?){2,60}$/;
export const emailMatch =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,70}))$/;
export const phoneMatch = /^((\+\d\d)?|(\d\d)?)([\s-]?(\d)){9}$/;
